// DataExplorerEditor — 'data' canvas view host. Extracted from the inline
// DataInspectorSlideOver wrapper that previously lived in canvas-area.tsx.
//
// Structure: DataCanvas on the left, DataInspector mounted via ResponsivePanel
// on the right (lg+ inline, md Sheet). selectedEntityId in useStudioStore
// drives both the panel's open state and DataInspector's entity binding.
import { Suspense } from 'react'
import { useStudioStore } from '@/store/studio-store'
import { ResponsivePanel } from '@/shell/responsive-panel'
import { DataCanvas } from './data-canvas'
import { DataInspector } from './data-inspector'

export function DataExplorerEditor({
  showCategoryTabs = true,
  visibleCategories,
}: {
  showCategoryTabs?: boolean
  visibleCategories?: readonly import("@/store/types").DataCategory[]
} = {}) {
  const selectedEntityId = useStudioStore((s) => s.selectedEntityId)
  const dataInspectorOpen = useStudioStore((s) => s.dataInspectorOpen)
  const setDataInspectorOpen = useStudioStore((s) => s.setDataInspectorOpen)
  const isOpen = !!selectedEntityId && dataInspectorOpen

  return (
    <div className="h-full flex overflow-hidden">
      <div className="flex-1 min-w-0 h-full">
        <DataCanvas
          showCategoryTabs={showCategoryTabs}
          visibleCategories={visibleCategories}
        />
      </div>
      <ResponsivePanel
        id="inspector"
        side="right"
        inlineFrom="lg"
        modalFrom="md"
        open={isOpen}
        onOpenChange={setDataInspectorOpen}
      >
        <Suspense
          fallback={
            <div className="p-4 text-sm text-muted-foreground">Loading...</div>
          }
        >
          {isOpen && (
            <DataInspector onRequestChat={() => setDataInspectorOpen(false)} />
          )}
        </Suspense>
      </ResponsivePanel>
    </div>
  )
}
